// @flow strict

import * as React from 'react';
import styles from './visibility.css';

export type Props = {
  children: React.Node,
  visible: boolean,
};

const visibilityFn: (string, string) => React.AbstractComponent<Props> = (
  visibleStyle: string,
  invisibleStyle: string
) => {
  const Visibility: React.AbstractComponent<Props> = ({
    visible,
    children,
  }: Props) => {
    return (
      <div className={visible ? visibleStyle : invisibleStyle}>{children}</div>
    );
  };
  return Visibility;
};

export default visibilityFn;
